var styles = {
  "Tabs": "Polaris-SkeletonTabs__Tabs",
  "Tab": "Polaris-SkeletonTabs__Tab",
  "TabText": "Polaris-SkeletonTabs__TabText",
  "fitted": "Polaris-SkeletonTabs--fitted"
};

export { styles as default };
